import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

import { unassignedSymbol } from '~/utils'

import { type QuestionSettingsInputQuestion } from '../../utils'

const schema = z.object({
  options: z.array(
    z.object({
      id: z.string().optional(),
      text: z.string(),
      attachedOptionMap: z.record(
        z.string(),
        z.union([z.number(), z.null(), z.literal(unassignedSymbol)]),
      ),
    }),
  ),
}) satisfies z.ZodSchema<{
  options: QuestionSettingsInputQuestion['options']
}>
export type InputValues = z.infer<typeof schema>
export const resolver = zodResolver(schema)
